import React from 'react'
import Resx from '@/components/Resx'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { Col, Label, ModalBody, Row } from 'reactstrap'
import RichTextWithAttachment from '@/components/messages/richtext-with-attachment'
import moment from 'moment'
import { defaultDateFormat } from '@/utils/dateUtilities'

function ViewMessageDialog (props) {
  const { message, attachments } = props

  const dueDateMoment = moment(message.dueDate)
  const dueDate = message.dueDate && dueDateMoment.isValid() ? dueDateMoment.format(defaultDateFormat) : ''

  return (
    <div>
      <BasicHeader title='Messages.MessageDraft' {...props} />
      <ModalBody>
        <Row>
          <Col xs='2'><Label><Resx name='Messages.Subject' /></Label></Col>
          <Col>{message.subject}</Col>
        </Row>
        <Row>
          <Col xs='2'><Label><Resx name='Messages.DueDate' /></Label></Col>
          <Col>{dueDate}</Col>
        </Row>
        <RichTextWithAttachment readOnly message={message} attachments={attachments} />
      </ModalBody>
    </div>)
}

export default {
  component: ViewMessageDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/viewMessage.js